export default __webpack_public_path__ + "static/media/lm4.32c25c50.webp";